module.exports = __webpack_public_path__ + "img/civilwedding2.9316b6bb.jpg";